import { Qualtrics } from './Qualtrics';

interface IQualtricsHTMLLoadProps {
  qualtricsZoneId: string;
}
export function QualtricsHTMLLoad({ qualtricsZoneId }: IQualtricsHTMLLoadProps) {
  return (
    <>
      <div id={qualtricsZoneId} dangerouslySetInnerHTML={{ __html: `<!--DO NOT REMOVE-CONTENTS PLACED HERE-->` }} />
    </>
  );
}
export const LoadQualtrics = (qualtricsZoneId: string) => {
  // The code below came from Dylan Swetish who currently owns qualtrics. This is supposed to be the snippet we load for any and all qualtrics
  // Qualtrics itself will associate the domain the traffic comes from with which form to load inside qualtrics
  // As of right now nothing in this code needs to change. There is possibly a cookie or local storage value we may want to save
  // that qualtrics could read that would pass to a form (such as userid, usertype etc).
  // Nothing in this code would need change as the zone id passed in will point to the right configuration
  try {
    new Qualtrics(
      100,
      'r',
      'QSI_S_' + qualtricsZoneId,
      'https://znagyjhfxnlbwptub-libertymutualvoc.siteintercept.qualtrics.com/SIE/?Q_ZID=' + qualtricsZoneId,
    ).start();
  } catch (i) {}
};
